<template>
  <v-row justify="center">
    <v-dialog
      :value="active"
      @click:outside="closeDialog"
      scrollable
      max-width="500"
    >
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
            rounded
            height="6"
          ></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Reciclar reporte
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <v-col cols="12">
                    <!-- <p class="grey--text caption pb-3">
                                            <v-icon small left color="blue-grey"
                                                >mdi-information</v-icon
                                            >Seleccione un rango de fecha para
                                            la búsqueda.
                                        </p> -->

                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          rules="required"
                          name="Fechas"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="dates"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            label="Rango de fecha"
                            :error-messages="errors"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                          >
                            Cancelar
                          </v-btn>
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateRangeMenu.save(dates)"
                          >
                            ok
                          </v-btn>
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- Cola -->
                  <v-col cols="12">
                    <v-select
                      v-model="queueToFilter"
                      prepend-inner-icon="mdi-tray-full"
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      item-text="name"
                      item-value="id"
                      :items="queueList"
                      label="Cola"
                      @change="getCampaigns"
                    ></v-select>
                  </v-col>

                  <!-- Campaña -->
                  <v-col cols="12">
                    <v-select
                      v-model="campaignToFilter"
                      prepend-inner-icon="mdi-bell"
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      item-text="name"
                      item-value="id"
                      :items="campaignList"
                      label="Campaña"
                      :disabled="queueToFilter == null || isLoadingCampaign"
                    ></v-select>
                  </v-col>

                  <!-- Tipificación -->
                  <v-col cols="12">
                    <v-select
                      v-model="tipificationToFilter"
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      item-text="name"
                      item-value="id"
                      :items="tipificationList"
                      label="Tipificación"
                      :disabled="queueToFilter == null || isLoadingtipification"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>
          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="handleSubmit(submitForm)"
              >
                Reciclar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
export default {
  components: { vuescroll },
  props: {
    active: {
      type: Boolean,
    },
  },

  data() {
    return {
      isLoading: false,
      isLoadingCampaign: true,
      isLoadingtipification: true,
      dateRangeMenu: false,
      dates: null,
      queueList: [],
      campaignList: [],
      tipificationList: [],
      queueToFilter: null,
      campaignToFilter: null,
      tipificationToFilter: null,
    };
  },

  created() {
    this.getQueues();
  },

  methods: {
    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get("/clients/listQueue");
        this.queueList = data.data.map((el) => ({
          ...el,
          name: `${el.name} - ${el.number}`,
        }));
      } catch (err) {
        console.log("error getting queue", err);
      }
    },

    async getCampaigns() {
      this.isLoadingCampaign = true;
      try {
        const { data } = await PbxHttpClient.get(
          `/campaign/campaign_select/${this.queueToFilter}`
        );
        this.campaignList = data;

        this.getTypification();
      } catch (err) {
        console.log("error getting campaign", err);
      }
      this.isLoadingCampaign = false;
    },

    async getTypification() {
      this.isLoadingtipification = true;
      try {
        const { data } = await PbxHttpClient.get(
          `/clients/typification/index_select/${this.queueToFilter}`
        );
        this.tipificationList = data;
      } catch (err) {
        console.log("error getting typification", err);
      }
      this.isLoadingtipification = false;
    },

    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.isLoading = true;
      try {
        // "/export/tiping",
        // {
        //   start,
        //   end,
        //   // user_id: 1923, typification_id: 14
        // },
        const [start, end] = this.dates;
        const { data } = await PbxHttpClient.post(`/typing/recycle_records`, {
          start,
          end,
          queue_id: this.queueToFilter,
          campaign_id: this.campaignToFilter,
          typification_id: this.tipificationToFilter,
        });

        this.$snotify.success(`${data.message}`, "Hecho!");

        //  await this.axios.post("/campaign/register", this.formData);

        // const url = window.URL.createObjectURL(new Blob([data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", `Reporte tipificación.xlsx`);
        // document.body.appendChild(link);
        // link.click();
      } catch (err) {
        if (err.response.data.error)
          this.$snotify.error(
            `No se pudo obtener los datos. ${err.response.data.error}`,
            "¡Error!"
          );

        console.log(err.response);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
